import { useQuery } from "@tanstack/react-query";
import { useApi } from "hooks/useApi";
import { useParams } from "react-router-dom";

export const useFetchVenues = () => {
  const { sport, organizationId } = useParams();
  const callApi = useApi();

  return useQuery({
    queryKey: ["venues", sport, organizationId],
    queryFn: () =>
      callApi(`/${sport}/o/${organizationId}/venues`, {
        defaultErrorMessage: "Can't fetch venues",
      }),
  });
};
